import script from "./RulesInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RulesInfo.vue?vue&type=script&setup=true&lang=js"

import "./RulesInfo.vue?vue&type=style&index=0&id=c35ba01e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c35ba01e"]])

export default __exports__